import { useEffect, useState } from "react";
function useIsVisible(ref) {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setIsVisible(entry.isIntersecting);
        }, {
            root: null,
            threshold: 0,
        });
        const element = ref.current;
        if (element) {
            observer.observe(element);
        }
        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [ref]);
    return isVisible;
}
export default useIsVisible;
